const SessionSvg = (props: any) => {
  if (props.outlined) {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.6667 2.66675C20.0907 2.66675 24.568 6.71475 25.2453 11.9534L28.2453 16.6721C28.4427 16.9827 28.4027 17.4454 27.9453 17.6427L25.3333 18.7601V22.6667C25.3333 24.1401 24.14 25.3334 22.6667 25.3334H20.0013L20 29.3334H8V24.4081C8 22.8347 7.41867 21.3454 6.34133 20.0014C4.876 18.1747 4 15.8561 4 13.3334C4 7.44275 8.776 2.66675 14.6667 2.66675ZM14.6667 5.33341C10.248 5.33341 6.66667 8.91475 6.66667 13.3334C6.66667 15.1801 7.29067 16.9241 8.42133 18.3334C9.88 20.1521 10.6667 22.2227 10.6667 24.4081V26.6667H17.3333L17.336 22.6667H22.6667V17.0027L24.7333 16.1174L22.676 12.8841L22.6 12.2947C22.088 8.33475 18.6987 5.33341 14.6667 5.33341ZM13.96 10.3507L14.6667 11.0574L15.3733 10.3507C16.2853 9.43875 17.7627 9.43875 18.6733 10.3507C19.5853 11.2614 19.5853 12.7387 18.6733 13.6494L14.6667 17.6574L10.66 13.6494C9.748 12.7387 9.748 11.2614 10.66 10.3507C11.5707 9.43875 13.048 9.43875 13.96 10.3507Z"
          fill="white"
        />
      </svg>
    )
  }
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6667 2.66675C20.0907 2.66675 24.568 6.71475 25.2453 11.9534L28.2453 16.6721C28.4427 16.9827 28.4027 17.4454 27.9453 17.6427L25.3333 18.7601V22.6667C25.3333 24.1401 24.14 25.3334 22.6667 25.3334H20.0013L20 29.3334H8V24.4081C8 22.8347 7.41867 21.3454 6.34133 20.0014C4.876 18.1747 4 15.8561 4 13.3334C4 7.44275 8.776 2.66675 14.6667 2.66675ZM13.96 10.3507C13.048 9.43875 11.5707 9.43875 10.66 10.3507C9.748 11.2614 9.748 12.7387 10.66 13.6494L14.6667 17.6574L18.6733 13.6494C19.5853 12.7387 19.5853 11.2614 18.6733 10.3507C17.7627 9.43875 16.2853 9.43875 15.3733 10.3507L14.6667 11.0574L13.96 10.3507V10.3507Z"
        fill="#00995D"
      />
    </svg>
  )
}

export default SessionSvg
